import React from 'react'
import { bool, func } from 'prop-types'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { rem } from 'polished'

import { authenticationMessages } from '../../../translations'
import { Grid } from '../../Grid'
import SocialButton from './SocialButton'
import { Twitter, Facebook, Twitch, Google, DiscordSimple } from '../../../icons'

const StyledGrid = styled(Grid)`
  padding-top: ${rem(36)};
  padding-bottom: ${rem(30)};
  row-gap: 0.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    justify-items: initial;
  }
`

export function Social({ token, openChild, fundraiser }) {
  const { formatMessage } = useIntl()
  const base = process.env.REACT_APP_ID_TILTIFY_URL
  const state = {
    fundraiser,
  }

  // eslint-disable-next-line
  const encode = btoa(JSON.stringify(state))

  const twitter = `${base}/auth/twitter?redirect_${token().type}=${token().value}&state=${encode}`
  const twitch = `${base}/auth/twitch?redirect_${token().type}=${token().value}&state=${encode}`
  const facebook = `${base}/auth/facebook?redirect_${token().type}=${token().value}&state=${encode}`
  const google = `${base}/auth/google?redirect_${token().type}=${token().value}&state=${encode}`
  const discord = `${base}/auth/discord?redirect_${token().type}=${token().value}&state=${encode}`

  return (
    <StyledGrid id='gtm_social-auth' itemWidth='195px'>
      <SocialButton
        openChild={openChild}
        text={formatMessage(authenticationMessages.continueTwitter)}
        link={twitter}
        icon={Twitter}
      />
      <SocialButton
        openChild={openChild}
        text={formatMessage(authenticationMessages.continueFacebook)}
        link={facebook}
        icon={Facebook}
      />
      <SocialButton
        openChild={openChild}
        text={formatMessage(authenticationMessages.continueTwitch)}
        link={twitch}
        icon={Twitch}
      />
      <SocialButton
        openChild={openChild}
        text={formatMessage(authenticationMessages.continueGoogle)}
        link={google}
        icon={Google}
      />
      <SocialButton
        openChild={openChild}
        text={formatMessage(authenticationMessages.continueDiscord)}
        link={discord}
        icon={DiscordSimple}
      />
    </StyledGrid>
  )
}

Social.defaultProps = {
  fundraiser: false,
}

Social.propTypes = {
  token: func,
  openChild: func,
  fundraiser: bool,
}
